import Slider from './Slider';

const addAnimationClassName = (el, className) => {
  const removeClassName = () => {
    el.removeEventListener('animationend', removeClassName);
    el.classList.remove(className);
  };
  el.classList.add(className);
  el.addEventListener('animationend', removeClassName);
};

class Carousel extends Slider {
  constructor(container, options) {
    super(container, {
      initClassName: 'carousel-set',
      childSelector: '.carousel__item',
      ...options,
    });
  }

  render() {
    if (!this.children.length) {
      // eslint-disable-next-line no-console
      console.trace('Elementos filhos não encontrados.', this);
      this.pause();
      return;
    }

    this.children.forEach((el, i) => {
      const pos = i - this.index;
      const order = pos < 0 ? this.children.length + pos : pos;

      // eslint-disable-next-line no-param-reassign
      el.style.order = order;
      el.setAttribute('data-order', order);

      el.classList.remove('slide-to-left');
      el.classList.remove('slide-to-right');

      if (this.direction < 0) {
        addAnimationClassName(el, 'slide-to-right');
      }

      if (this.direction > 0) {
        addAnimationClassName(el, 'slide-to-left');
      }
    });

    this.trigger('render');
  }
}

export default Carousel;
